import { motion } from 'framer-motion';

function Disclaimer() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="container mx-auto px-4 py-8 max-w-4xl"
    >
      <h1 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
        Disclaimer
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Website Disclaimer</h2>
          <p>
            The information provided on this website is for general informational purposes only. 
            While we strive to keep the information up to date and correct, we make no representations 
            or warranties of any kind about the completeness, accuracy, reliability, suitability, 
            or availability of the website or the information, products, services, or related graphics 
            contained on the website.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">External Links</h2>
          <p>
            Our website may contain links to external websites. We have no control over the content 
            and nature of these sites and are not responsible for their content or privacy practices.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">User-Generated Content</h2>
          <p>
            Views expressed in user-generated content are those of the respective user and do not 
            necessarily reflect our views. We are not responsible for user-generated content.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
          <p>
            In no event shall we be liable for any loss or damage including without limitation, 
            indirect or consequential loss or damage, arising from loss of data or profits arising 
            out of, or in connection with, the use of this website.
          </p>
        </section>
      </div>
    </motion.div>
  );
}

export default Disclaimer; 